export { default } from './DashboardSettingsModal';
export { default as reducer } from './DashboardSettingsModal.ducks';
